var _path, _g, _path2, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisorBici(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_63_1042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.96606H9.29396V18.8572H0V9.96606Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_63_1042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_63_1042",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.647 9.96606C2.08483 9.96606 0 11.9602 0 14.4119C0 16.8635 2.08483 18.8572 4.647 18.8572C7.20967 18.8572 9.294 16.8635 9.294 14.4119C9.294 11.9602 7.20967 9.96606 4.647 9.96606Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.647 8.46606C1.31977 8.46606 -1.5 11.0698 -1.5 14.4119H1.5C1.5 12.8506 2.84989 11.4661 4.647 11.4661V8.46606ZM-1.5 14.4119C-1.5 17.7541 1.31996 20.3572 4.647 20.3572V17.3572C2.8497 17.3572 1.5 15.9729 1.5 14.4119H-1.5ZM4.647 20.3572C7.97465 20.3572 10.794 17.754 10.794 14.4119H7.794C7.794 15.973 6.44469 17.3572 4.647 17.3572V20.3572ZM10.794 14.4119C10.794 11.0699 7.97484 8.46606 4.647 8.46606V11.4661C6.4445 11.4661 7.794 12.8505 7.794 14.4119H10.794Z",
    fill: "#6E6259",
    mask: "url(#path-2-inside-1_63_1042)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_63_1042",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 9,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7061 9.96606H24V18.8572H14.7061V9.96606Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_63_1042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_63_1042",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3531 9.96606C16.7909 9.96606 14.7061 11.9602 14.7061 14.4119C14.7061 16.8635 16.7909 18.8572 19.3531 18.8572C21.9157 18.8572 24.0001 16.8635 24.0001 14.4119C24.0001 11.9602 21.9157 9.96606 19.3531 9.96606Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.3531 8.46606C16.0258 8.46606 13.2061 11.0698 13.2061 14.4119H16.2061C16.2061 12.8506 17.5559 11.4661 19.3531 11.4661V8.46606ZM13.2061 14.4119C13.2061 17.7541 16.026 20.3572 19.3531 20.3572V17.3572C17.5558 17.3572 16.2061 15.9729 16.2061 14.4119H13.2061ZM19.3531 20.3572C22.6807 20.3572 25.5001 17.754 25.5001 14.4119H22.5001C22.5001 15.973 21.1507 17.3572 19.3531 17.3572V20.3572ZM25.5001 14.4119C25.5001 11.0699 22.6809 8.46606 19.3531 8.46606V11.4661C21.1506 11.4661 22.5001 12.8505 22.5001 14.4119H25.5001Z",
    fill: "#6E6259",
    mask: "url(#path-5-inside-2_63_1042)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1643 13.061L9.42621 8.7737H14.7765L11.1643 13.061ZM16.5037 8.55509C16.5085 8.549 16.5125 8.5429 16.5169 8.53729C16.5336 8.51566 16.5479 8.49355 16.5606 8.47061C16.566 8.46177 16.5704 8.45281 16.5749 8.44337C16.5866 8.41947 16.5968 8.39558 16.6048 8.37072C16.6072 8.36367 16.6101 8.3571 16.6121 8.35005C16.6204 8.31863 16.6268 8.2872 16.6302 8.25482C16.6312 8.24586 16.6312 8.2369 16.6317 8.22758C16.6332 8.20177 16.6327 8.17692 16.6302 8.15111C16.6293 8.14119 16.6287 8.13223 16.6273 8.12243C16.6224 8.08922 16.6154 8.0554 16.6037 8.02206V8.01932L15.8435 5.8074C15.7401 5.50522 15.4001 5.34153 15.0853 5.44046C14.7699 5.53952 14.5983 5.86464 14.7013 6.16586L15.202 7.6237H8.54814C8.34994 7.6237 8.1646 7.7175 8.05232 7.87378C7.94041 8.03043 7.91644 8.22997 7.988 8.40681L10.4192 14.4044C10.4972 14.5953 10.6752 14.7328 10.8876 14.7647C10.918 14.7684 10.9493 14.7712 10.9803 14.7712C11.1603 14.7712 11.333 14.6939 11.4476 14.5568L16.5003 8.55975C16.5018 8.55832 16.5022 8.55652 16.5037 8.55509Z",
    fill: "#6E6259"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68631 7.16482H9.45979C9.79238 7.16482 10.0612 6.90721 10.0612 6.58961C10.0612 6.2719 9.79238 6.01477 9.45979 6.01477H6.68631C6.35484 6.01477 6.08545 6.2719 6.08545 6.58961C6.08545 6.90721 6.35484 7.16482 6.68631 7.16482Z",
    fill: "#6E6259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisorBici);
export default __webpack_public_path__ + "static/media/visor-bici.60ad96e3.svg";
export { ForwardRef as ReactComponent };